import axios from 'axios';
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/dist/ScrollToPlugin';
window.gsap = gsap;
gsap.registerPlugin(ScrollToPlugin);

// form vars
const careerForm = document.querySelector('#career-form');
const careerFormWrap = document.querySelector('#career-form-wrapper');
// ajax loader
let loader = document.createElement('div');
loader.className = 'lds-ripple';
loader.appendChild(document.createElement('div'));
loader.appendChild(document.createElement('div'));
// form submit
careerForm.addEventListener('submit', (event) => {
	event.preventDefault();
	let formData = new FormData(careerForm);
	careerForm.classList.add('ajaxing');
	careerForm.append(loader);
	formData.append('action', 'career_form');
	// form ajax
	axios
		.post(ajaxurl, formData)
		.then((response) => {
			// console.log(response);
			// remove ajax and loader
			careerForm.classList.remove('ajaxing');
			loader.remove();
			// form response and status vars
			let formMessage = careerFormWrap.querySelector('.form-response');
			formMessage.innerHTML = '';
			let formStatus;
			if (response.data !== '' && response.data.constructor === Object) {
				formStatus = response.data.status;
			} else {
				formStatus = response.data;
			}
			// get response message based on status
			let responseMessage = careerFormWrap.querySelector('.template-' + formStatus).content.cloneNode(true);
			if (formStatus == 'success') {
				careerFormWrap.innerHTML = '';
				careerFormWrap.append(responseMessage);
				careerFormWrap.classList.add('career-form-success');
				// send GA conversion
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					event: 'formSubmission',
					formType: 'Career',
				});
			} else {
				formMessage.append(responseMessage);
				formMessage.classList.add('form-response--' + formStatus);
				response.data.errors.forEach((error) => {
					let list = document.createElement('li');
					list.textContent = error;
					careerFormWrap.querySelector('#career-form-errors').append(list);
				});
			}
			// scroll response into view
			gsap.to(window, { delay: 0.2, duration: 0.7, scrollTo: { y: '.career-form', offsetY: 100 }, ease: 'sine.out' });
		})
		.catch((error) => {
			console.log(error);
			careerForm.classList.remove('ajaxing');
			loader.remove();
		});
});
